import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import messages from 'modules/booking/messages';
import { ReactComponent as UsersCancelIcon } from 'img/icons/users-cancel.svg';
import { IEventPersonEntity, PersonAppointmentStatus } from 'modules/booking/interfaces';
import { ActionItem } from 'common/components';
import { publicCase } from 'common/utils/stringFormat';
import BookingActionItemContainer from 'components/Booking/BookingActionItemContainer';
import ActionItemWarningIcon from 'common/components/ActionsMenu/ActionItemWarningIcon';

interface IBookingActionItemCancelParticipation {
  onClick: () => void;
  userId: number;
  eventPersons: IEventPersonEntity[];
  appointmentStatus: PersonAppointmentStatus;
  isEventCanceled: boolean;
}

const BookingActionItemCancelParticipation: FC<IBookingActionItemCancelParticipation> = ({
  onClick,
  userId,
  eventPersons,
  appointmentStatus,
  isEventCanceled,
}) => {
  const intl = useIntl();
  const person = eventPersons.find(item => item.customer?.id === userId);
  const isUserInWaitList = person && person.waitList ? person.waitList : false;
  const isConfirmed = appointmentStatus === PersonAppointmentStatus.Confirmed;
  const isPending = appointmentStatus === PersonAppointmentStatus.Pending;
  const allowCancel = isConfirmed || isPending;
  let disableReason: JSX.Element | null = null;

  if (isEventCanceled) {
    disableReason = (
      <ActionItemWarningIcon tooltipMessage={intl.formatMessage(messages.eventIsCanceled)} />
    );
  } else if (isUserInWaitList) {
    disableReason = (
      <ActionItemWarningIcon tooltipMessage={intl.formatMessage(messages.userInWaitList)} />
    );
  } else if (!allowCancel) {
    const tooltipMessage = intl.formatMessage(messages.cancelRestrictionByStatus, {
      status: publicCase(appointmentStatus),
    });

    disableReason = <ActionItemWarningIcon tooltipMessage={tooltipMessage} />;
  }

  const disabled = !!disableReason;

  return (
    <ActionItem
      key="cancelParticipationAction"
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      icon={<UsersCancelIcon />}
    >
      <BookingActionItemContainer message={intl.formatMessage(messages.cancelParticipation)}>
        {disableReason}
      </BookingActionItemContainer>
    </ActionItem>
  );
};

export default BookingActionItemCancelParticipation;
